<template>
  <div class="goods-container dailydeals" :style="{ backgroundColor }">
    <div :class="goodShowType">
    <div class="title" v-if="showTitleDailyDeals">
      <span
        class="cap-title-title-title"
        :style="{ color: titleColor }"
        :class="{ bold: titleBold }"
        >{{ titleDailyDeals }}</span
      >
    </div>
    <div class="titlePic" v-if="showTitlePicDailyDeals">
      <img
        :src="titlePicDailyDeals"
        class="img"
        alt
      />
    </div>
    <div v-if="showSubTitleTopDailyDeals">
      <div
        class="subtitle cap-title-title-sub flex-1"
        :style="{ color: subTitleColor }"
        :class="{ bold: subTitleBoldTop,'text-right': subTitleTextAlign }"
      >
        {{ subTitleDailyDeals }}
      </div>
    </div>
    <el-carousel class="carousel" arrow="always" :autoplay="true" indicator-position="none" :interval="(interval*1000)" :height="carouselheight()">
      <el-carousel-item v-for="(v, i) in Array2(goodsList)" :key="i">
        <ul
          class="cap-goods-layout__container show-column"
          :style="{ paddingLeft: padding + 'px', paddingRight: padding + 'px' }"
        >
          <li
            class="cap-goods-layout__wrapper"
            :class="{ radius: borderRadius }"
            v-for="(v2, i2) in v"
            :key="i2"
          >
            <div
              class="cap-goods-layout__item"
              :class="{ radius: borderRadius }"
              :style="{ margin: marginBottom + 'px' }"
            >
              <div class="cap-goods__photo">
                <div class="cap-goods__image-wrap">
                  <img
                    :src="v2.spuMainPic"
                    class="img"
                    alt
                    :class="{ radius: borderRadius }"
                  />
                </div>
              </div>
              <!-- <div class="cap-goods-layout__info">
                <div class="cap-goods-layout__info-title">
                  <div class="goods-title" :class="{ bold: titleBold }">
                    {{ v2.wxshopSpuName }}
                  </div>
                </div>
              </div> -->
            </div>
          </li>
        </ul>
      </el-carousel-item>
    </el-carousel>
    </div>

    <div :class="goodShowType">
    <div class="title" v-if="showTitleDailyNews">
      <span
        class="cap-title-title-title"
        :style="{ color: titleColor }"
        :class="{ bold: titleBold }"
        >{{ titleDailyNews }}</span
      >
    </div>
    <div class="titlePic" v-if="showTitlePicDailyNews">
      <img
        :src="titlePicDailyNews"
        class="img"
        alt
      />
    </div>
    <div v-if="showSubTitleTopDailyNews">
      <div
        class="subtitle cap-title-title-sub flex-1"
        :style="{ color: subTitleColor }"
        :class="{ bold: subTitleBoldTop,'text-right': subTitleTextAlign }"
      >
        {{ subTitleDailyNews }}
      </div>
    </div>
    <el-carousel class="carousel" arrow="always" :autoplay="true" indicator-position="none" :interval="(interval*1000)" :height="carouselheight()">
      <el-carousel-item v-for="(v, i) in Array2(goodsList3)" :key="i">
        <ul
          class="cap-goods-layout__container show-column"
          :style="{ paddingLeft: padding + 'px', paddingRight: padding + 'px' }"
        >
          <li
            class="cap-goods-layout__wrapper"
            :class="{ radius: borderRadius }"
            v-for="(v2, i2) in v"
            :key="i2"
          >
            <div
              class="cap-goods-layout__item"
              :class="{ radius: borderRadius }"
              :style="{ margin: marginBottom + 'px' }"
            >
              <div class="cap-goods__photo">
                <div class="cap-goods__image-wrap">
                  <img
                    :src="v2.spuMainPic"
                    class="img"
                    alt
                    :class="{ radius: borderRadius }"
                  />
                </div>
              </div>
              <!-- <div class="cap-goods-layout__info">
                <div class="cap-goods-layout__info-title">
                  <div class="goods-title" :class="{ bold: titleBold }">
                    {{ v2.wxshopSpuName }}
                  </div>
                </div>
              </div> -->
            </div>
          </li>
        </ul>
      </el-carousel-item>
    </el-carousel>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    borderRadius: {
      type: Boolean,
      default: false,
    },
    titleBold: {
      type: Boolean,
      default: false,
    },
    padding: {
      type: Number,
      default: 5,
    },
    marginBottom: {
      type: Number,
      default: 5,
    },
    titleBold: {
      type: Boolean,
      default: false,
    },
    subTitleBoldTop: {
      type: Boolean,
      default: false,
    },
    subTitleTextAlign:{
      type: Boolean,
      default: false,
    },
    titleColor: {
      type: String,
      default: "#2b2b2b",
    },
    subTitleColor: {
      type: String,
      default: "#969799",
    },
    backgroundColor: {
      type: String,
      default: "#fff",
    },
    interval: {
      type: Number,
      default: 3,
    },
    goodShowType: {
      type: String,
      default: "left",
    }, 
    goodsList: {
      type: Array,
      default: () => [],
    },
    goodsList2: {
      type: Array,
      default: () => [],
    },
    goodsList3: {
      type: Array,
      default: () => [],
    },
    goodsList4: {
      type: Array,
      default: () => [],
    },
    titleDailyDeals: {
      type: String,
      default: "",
    },
    subTitleDailyDeals: {
      type: String,
      default: "",
    },
    showTitleDailyDeals: {
      type: Boolean,
      default: false,
    },
    showSubTitleTopDailyDeals: {
      type: Boolean,
      default: false,
    },    
    titlePicDailyDeals:{
      type: String,
      default: "",
    },
    showTitlePicDailyDeals:{
      type: Boolean,
      default: false,
    },
    titleDailyNews: {
      type: String,
      default: "",
    },
    subTitleDailyNews: {
      type: String,
      default: "",
    },
    showTitleDailyNews: {
      type: Boolean,
      default: false,
    },
    showSubTitleTopDailyNews: {
      type: Boolean,
      default: false,
    },
    titlePicDailyNews:{
      type: String,
      default: "",
    },
    showTitlePicDailyNews:{
      type: Boolean,
      default: false,
    },
  },
  components: {},
  data() {
    return {};
  },
  computed: {},
  watch: {},
  created() {},
  mounted() {},
  onshow(){
    this.Array2();
  },
  methods: {
    formatArray(data, num) {
      var dataList2 = []
      for (var i = 0, len = data.length; i < len; i += num) {
        dataList2.push(data.slice(i, i + num))
      }
      return dataList2
    },
    Array2(goodsList){
      var goodsList2=[];
      goodsList2 = this.formatArray(goodsList, 2);
      
      return goodsList2;      
    },
    carouselheight(){
      var height=0;
        height = 100;
      return height+"px";
    }
  },
};
</script>
<style lang="scss" scoped>
.cap-goods__image-wrap {
  position: relative;
  overflow: hidden;
  max-height: 500px;
  .img {
    width: 100%;
  }
  .img.radius {
    border-top-left-radius: 5px;
    border-top-right-radius: 5px;
  }
}

.goods-container {
  overflow: hidden;
}

.cap-goods-layout__wrapper {
  position: relative;
  min-height: 50px;
  color: #333;
  box-sizing: border-box;
  overflow: hidden;
  line-height: 16px;
  .cap-goods-layout__item {
    background-color: #fff;
    margin: 5px;
    &.radius {
      border-radius: 10px;
    }
  }
  &.radius {
    border-bottom-left-radius: 10px;
    border-bottom-right-radius: 10px;
  }
}

.cornor-logo {
  position: absolute;
  z-index: 100;
  top: 13px;
  left: 10px;
  width: 66px;
  height: 26px;
  text-align: center;
  line-height: 26px;
  background: linear-gradient(270deg, #ff9292, #e50000);
  border-radius: 19px 13px 13px 0px;
  color: #fff;
}

.custom-logo {
  position: absolute;
  z-index: 100;
  top: 13px;
  left: 0;
  width: 66px;
}

.bold {
  font-weight: bold !important;
}

.cap-goods-layout__container {
  &.show-column {
    display: flex;
    flex-wrap: wrap;
    flex-direction: flex-start;
    justify-content: space-between;
    .cap-goods-layout__wrapper {
      width: 50%;
    }
  }
  &.three-column {
    // column-count: 3;
    // column-gap: 5px;
    // display: inline-block;
    display: flex;
    flex-wrap: wrap;
    flex-direction: flex-start;
    .cap-goods-layout__wrapper {
      width: 33.33%;
    }
  }
  &.four-column {
    // column-count: 3;
    // column-gap: 5px;
    // display: inline-block;
    display: flex;
    flex-wrap: wrap;
    flex-direction: flex-start;
    .cap-goods-layout__wrapper {
      width: 25%;
    }
  }
  &.scroll {
    display: flex;
    flex-wrap: nowrap;
    -webkit-overflow-scrolling: touch;
    padding-bottom: 10px;
    margin-bottom: -10px;
    overflow-x: auto;
    overflow-y: hidden;
    white-space: nowrap;
    width: 100%;
    .cap-goods-layout__wrapper {
      flex-basis: 172px;
      flex-shrink: 0;
      white-space: nowrap;
      white-space: nowrap;
    }
  }
}

.cap-goods-layout__info {
  padding: 0 10px;
  position: relative;
  .cap-goods-layout__info-title {
    margin: 10px 0 0;
    .goods-title {
      font-size: 14px;
      line-height: 20px;
      max-height: 20px;
      margin-bottom: 5px;
      word-break: break-all;
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-line-clamp: 1;
      -webkit-box-orient: vertical;
    }
    .sub-title {
      font-size: 12px;
      line-height: 16px;
      color: #999;
      height: 16px;
      word-break: break-all;
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-line-clamp: 1;
      -webkit-box-orient: vertical;
    }
  }
}

.cap-goods-layout__info-price {
  height: 44px;
  .cart {
    color: rgb(255, 68, 68);
    font-size: 18px;
  }

  .sale-price {
    color: #f44;
    height: 16px;
    line-height: 16px;
    font-size: 16px;
    word-break: break-all;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    .price-tag {
      font-size: 12px;
      margin-right: 2px;
    }

    .sale-price__origin {
      height: 12px;
      line-height: 12px;
      font-size: 12px;
      color: #999;
      margin-top: 2px;
      font-weight: 400;
      text-decoration: line-through;
    }
  }
}

.sale-num {
  font-size: 12px;
  margin-left: 5px;
  color: #999;
}
.dailydeals {
  .left{
    width: 50%;
    float: left;
  }
  .right{
    width: 50%;
    float: right;
  }
  padding: 18px 0 10px 0;
  .title {
    margin: 0 5px 0 10px;
    font-size: 18px;
    height: 30px;
    line-height: 30px;
    display: inline-block;
  }
  .titlePic{
    margin: 0 5px 0 10px;
    height: 30px;
    width: auto;
    display: inline-block;
    overflow: hidden;
    .img{
      width: auto;
      height: 30px;
    }
  }
  .subtitle {
    margin: 0 10px;
    // height: 18px;
    line-height: 18px;
    // border: 1px solid #dddddd;
    // border-radius: 20px;
    // padding: 0 10px;
    // display: inline-block;
    font-size: 14px;
  }
  .carousel{ height: auto; width: 100%;}
}
</style>
